import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { TeamCoverageView } from '@apps/web/components/settings/team_coverage_view';
import {
    SettingsLoadingState,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/team-coverage')({
    component: TeamCoveragePage,
});

function TeamCoveragePage() {
    const { organizationId, isLoading } = useSettingsGates();

    if (isLoading || organizationId === null) {
        return <SettingsLoadingState />;
    }

    return (
        <div className="mx-auto w-full max-w-7xl shrink-0 space-y-9 px-10 py-12 max-md:px-4 max-md:py-6">
            <div className="space-y-3">
                <Link
                    to="/settings/phoebe"
                    className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm font-medium transition-colors pointer-coarse:min-h-11"
                >
                    <ArrowLeft className="size-4" />
                    Phoebe
                </Link>
                <div className="space-y-1.5">
                    <h1 className="text-foreground text-[28px] font-semibold tracking-tight">
                        Team coverage
                    </h1>
                    <p className="text-muted-foreground text-[15px]">
                        Who gets asked, and who gets told.
                    </p>
                </div>
            </div>
            <TeamCoverageView organizationId={organizationId} />
        </div>
    );
}
